module.exports = __webpack_public_path__ + "img/refresh.395a0762.svg";